Namespace 'Models'

class Models.InstagramMessage
  constructor: (builder) ->
    @time = builder.time
    @senderId = builder.senderId
    @recipientId = builder.recipientId
    @timestamp = builder.timestamp
    @messageId = builder.messageId
    @reactions = builder.reactions

  accepts: (visitor) ->
    throw new Error('Not implemented')

  getType: ->
    throw new Error('Not implemented')
